import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import theme from 'src/config/theme';

export interface NavigationBarState {
  isNavigationBarOpen: boolean;
  width: number;
  activeItem: string | null;
  place: null | 'trajectory' | 'table-of-contents' | 'presentation-mode';
}

const initialState: NavigationBarState = {
  isNavigationBarOpen: false,
  width: theme.config.closedNavigationBarWidth,
  place: null,
  activeItem: null,
};

const navigationBarSlice = createSlice({
  name: 'navigationBar',
  initialState,
  reducers: {
    setNavigationBarStatus: (
      state,
      action: PayloadAction<NavigationBarState['isNavigationBarOpen']>
    ) => {
      const newWidth = action.payload
        ? theme.config.openNavigationBarWidth
        : theme.config.closedNavigationBarWidth;
      return { ...state, isNavigationBarOpen: action.payload, width: newWidth };
    },
    setNavigationPlace: (state, action: PayloadAction<NavigationBarState['place']>) => {
      return { ...state, place: action.payload };
    },
    setActiveItem: (state, action: PayloadAction<NavigationBarState['activeItem']>) => {
      return { ...state, activeItem: action.payload };
    },
    resetNavigationBar: () => {
      return initialState;
    },
  },
});

export const { setNavigationBarStatus, setNavigationPlace, setActiveItem, resetNavigationBar } =
  navigationBarSlice.actions;

export const { reducer: navigationBarReducer } = navigationBarSlice;
